module.exports = __webpack_public_path__ + "img/y_2016_hover.03568594.png";